module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/_next/static/images/slideshow-2-02482bd7ab694224e54c42f2ff452579.png";